/* eslint-disable @typescript-eslint/explicit-function-return-type */
import * as Yup from 'yup';

export const getValidationSchema = () =>
  Yup.object().shape({
    resumingFromLeaveRequestId: Yup.number().required(
      'Please choose leave request you are resuming from'
    ),
    resumingOnDate: Yup.string().test(
      'Validate is chosen date',
      'Please choose resuming date',
      (date) => {
        const isNotDev =
          window.location.href.includes('dev.') ||
          window.location.href.includes('qa.') ||
          window.location.href.includes('localhost');

        if (!isNotDev) {
          return Boolean(date);
        }

        return true;
      }
    ),
    workShift: Yup.number().required('Please choose work shift'),
    currentLocation: Yup.string().required('Please type your current location'),
    remarks: Yup.string().max(100),
  });
